import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";

import Spinner from "presentation/components/Shared/Spinner";

interface GalleryImage {
  key: string;
  url?: string;
}

interface EquipmentGalleryDialogProps {
  visible: boolean;
  loading: boolean;
  images: GalleryImage[];
  activeIndex: number;
  isAdminOrPatrimonio: boolean;
  addPhotosInputRef: React.RefObject<HTMLInputElement | null>;
  onHide: () => void;
  onAddPhotos: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectImage: (index: number) => void;
}

const EquipmentGalleryDialog: React.FC<EquipmentGalleryDialogProps> = ({
  visible,
  loading,
  images,
  activeIndex,
  isAdminOrPatrimonio,
  addPhotosInputRef,
  onHide,
  onAddPhotos,
  onSelectImage,
}) => {
  return (
    <Dialog
      header="Galeria de Fotos do Movimento"
      visible={visible}
      style={{ width: "60vw" }}
      contentStyle={{ minHeight: "450px" }}
      onHide={onHide}
      footer={
        <div className="flex justify-content-end gap-2">
          <input
            ref={addPhotosInputRef}
            type="file"
            accept="image/*"
            multiple
            style={{ display: "none" }}
            onChange={onAddPhotos}
          />
          {isAdminOrPatrimonio && (
            <Button
              label="Adicionar Foto(s)"
              icon="pi pi-plus"
              onClick={() => addPhotosInputRef.current?.click()}
              className="p-button-outlined p-button-sm"
              disabled={loading}
            />
          )}
          <Button
            label="Fechar"
            icon="pi pi-times"
            onClick={onHide}
            className="p-button-text p-button-sm"
          />
        </div>
      }
    >
      {loading && <Spinner />}
      {!loading && images.length > 0 && (
        <div className="flex flex-column align-items-center gap-3">
          <div
            className="w-full flex justify-content-center align-items-center bg-gray-100 border-round p-2"
            style={{ minHeight: "350px", maxHeight: "500px" }}
          >
            <img
              src={images[activeIndex]?.url}
              alt="Foto do Equipamento"
              style={{
                maxWidth: "100%",
                maxHeight: "480px",
                objectFit: "contain",
              }}
            />
          </div>

          {images.length > 1 && (
            <div className="flex justify-content-center gap-2 overflow-x-auto w-full py-2">
              {images.map((image, index) => (
                <div
                  key={image.key}
                  className={`border-2 border-round cursor-pointer overflow-hidden ${
                    index === activeIndex
                      ? "border-primary"
                      : "border-transparent"
                  }`}
                  style={{ width: "60px", height: "60px" }}
                  onClick={() => onSelectImage(index)}
                >
                  <img
                    src={image.url}
                    alt={`Miniatura ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {!loading && images.length === 0 && (
        <div className="text-center py-4 text-gray-500">
          Nenhuma foto disponível nesta galeria.
        </div>
      )}
    </Dialog>
  );
};

export default EquipmentGalleryDialog;
